import { useParams, useLocation, useOutletContext } from 'react-router-dom'
import { LayerMetadataForm } from './LayerMetadataForm'
import { useLayerMetadata } from '@app/modules/Home/Data/hooks/useLayerMetadata'
import { DataLayerDetailOutletContext } from '@app/modules/Home/Data/types'
import { buildLayerMetadataFromDetail } from '@app/domains/layers/utils/layerMetadataDefaults'
import { LayerSourceLink } from '@app/types/layerTypes'

export const LayerMetadataManagement = () => {
  const { layerId } = useParams<{ layerId: string }>()
  const { state } = useLocation()
  const { selectedLayerDetail } = useOutletContext<DataLayerDetailOutletContext>()
  const layerMeta = useLayerMetadata(layerId)

  const defaults =
    layerMeta?.metadata ??
    buildLayerMetadataFromDetail(selectedLayerDetail?.layerDetail?.[0] ?? null, layerMeta?.title)

  const mergedSources: LayerSourceLink[] = state?.allSources ?? defaults.source_links ?? []

  return (
    <LayerMetadataForm
      key={layerMeta?.id ?? layerId}
      layerId={layerMeta?.id ?? layerId ?? ''}
      defaultValues={{
        ...defaults,
        source_links: mergedSources,
      }}
    />
  )
}
